import Image from 'next/image';
import type { SealsWidgetResolved } from './types';
import { imageAlt } from '@/lib/render/imageAlt';
import { useRenderContext } from '@/lib/render/RenderContextProvider';
import { RichText } from '@/lib/render/RichText';

export function SealsComponent({
  resolved,
}: {
  resolved: SealsWidgetResolved;
}) {
  const { imageUrl, substitutePlaceholders: sub } = useRenderContext();
  const seals = resolved.seals ?? [];

  if (seals.length === 0) {
    return null;
  }

  return (
    <section className="pt-4">
      <div className="mb-10 grid gap-8 md:grid-cols-3">
        {seals.map((seal) => (
          <div key={seal.id} className="flex flex-col items-center text-center">
            {/* The caption names the award and labels the tooltip; the
                media's own alt text describes the picture and wins when an
                editor has filled it in. */}
            {seal.image && (
              <Image
                src={imageUrl(seal.image)}
                alt={sub(imageAlt(seal.image, seal.caption ?? ''))}
                title={seal.caption}
                width={200}
                height={200}
                className="mb-4 h-50 object-contain"
                loading="lazy"
              />
            )}
            {seal.description && (
              <div className="text-sm text-gray-700">
                <RichText nodes={seal.description} />
              </div>
            )}
          </div>
        ))}
      </div>
    </section>
  );
}
